<div class="grid-container margin-top">
    <ag-grid-angular class="data-grid  full-page" [gridOptions]="gridOptions" [rowData]="allGroups | async" aria-label="Manage Groups"></ag-grid-angular>
</div>
<confirm-dialog [showDialog]="dialogService.showDialog" [dialogType]="dialogService.dialogType" [message]="dialogService.message" (onDialogConfirm)="onDialogConfirm()" (onDialogClose)="onDialogClose()"></confirm-dialog>
